// extracted by mini-css-extract-plugin
module.exports = {"tourCaretakerList":"Caretakers_tourCaretakerList__3Oiql"};